import type { ColumnType } from 'antd/es/table/interface'
import { useCallback } from 'react'

import { useColumnCustomSearchFilter } from './useColumnCustomSearchFilter'
/**
 * client-side Ant Table columns filter by two dataIndexes simultaneously
 */
export function useDualColumnSearchFilter<T>() {
  const { getCustomSearchFilter } = useColumnCustomSearchFilter<T>()

  const getDualSearchFilter = useCallback(
    (
      firstIndex: keyof T,
      secondIndex: keyof T,
      placeholder?: string
    ): ColumnType<T> => {
      const onFilter = (value: string, record: T) => {
        const searchValue = value.toLowerCase()
        const firstValue = record[firstIndex]?.toString().toLowerCase() || ''
        const secondValue = record[secondIndex]?.toString().toLowerCase() || ''
        return (
          firstValue.includes(searchValue) || secondValue.includes(searchValue)
        )
      }
      return getCustomSearchFilter(onFilter, placeholder)
    },
    [getCustomSearchFilter]
  )
  return { getDualSearchFilter }
}
